(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tyga-home-films"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tyga-on-demand-film')) {
  customElements.define('tyga-on-demand-film', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) return;
      this.bound = true;
      this.button.hidden = false;
      this.onClick = () => {
        this.querySelector('[role="status"]').textContent = '';
        if (!this.video.getAttribute('src')) this.video.src = this.video.dataset.src;
        this.video.hidden = false;
        this.video.muted = true;
        this.video.play().then(() => { this.button.hidden = true; this.video.focus(); }).catch(() => this.onError());
      };
      this.onPlay = () => {
        document.querySelectorAll('tyga-on-demand-film video, tyga-hero-film video').forEach(video => { if (video !== this.video) video.pause(); });
      };
      this.onError = () => {
        this.video.hidden = true;
        this.button.hidden = false;
        this.querySelector('[role="status"]').textContent = this.dataset.error;
      };
      this.onVisibility = () => { if (document.hidden) this.video.pause(); };
      this.button.addEventListener('click', this.onClick);
      this.video.addEventListener('play', this.onPlay);
      this.video.addEventListener('error', this.onError);
      document.addEventListener('visibilitychange', this.onVisibility);
      this.observer = new IntersectionObserver(entries => { if (!entries[0].isIntersecting) this.video.pause(); }, {threshold:0.1});
      this.observer.observe(this);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.button?.removeEventListener('click', this.onClick);
      this.video?.removeEventListener('play', this.onPlay);
      this.video?.removeEventListener('error', this.onError);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.bound = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
